import React from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { VaLink } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { INTENT_TO_FILE_PATH } from '../constants';

export default function IntentToFileSection() {
  const navigate = useNavigate();

  const handleIntentToFileLinkClick = e => {
    e.preventDefault();
    navigate(`/${INTENT_TO_FILE_PATH}`);
  };

  return (
    <div className="intent-to-file-section vads-u-margin-top--4 vads-u-margin-bottom--4">
      <h2 id="your-intents-to-file">Your intents to file</h2>
      <VaLink
        active
        className="vads-u-margin-top--1p5"
        href={`/track-claims/${INTENT_TO_FILE_PATH}`}
        text="Review your intents to file or learn how to start one"
        onClick={handleIntentToFileLinkClick}
      />
      <p className="vads-u-margin-y--0p5">
        An intent to file sets a potential start date for your VA disability,
        pension, or Dependency and Indemnity Compensation (DIC) benefits.
      </p>
    </div>
  );
}
